var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosebtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 70,
    viewBox: "0 0 122 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.0244 0.5L121.131 69.5H39.0762L0.848633 0.5H81.0244Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.264 25.319C68.6894 24.8937 69.3791 24.8937 69.8045 25.319C70.2299 25.7444 70.2299 26.4341 69.8045 26.8595L52.8596 43.8043C52.4343 44.2297 51.7446 44.2297 51.3192 43.8043C50.8938 43.3789 50.8938 42.6893 51.3192 42.2639L68.264 25.319Z",
    fill: "#157438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8043 42.2639C70.2297 42.6893 70.2297 43.3789 69.8043 43.8043C69.3789 44.2297 68.6893 44.2297 68.2639 43.8043L51.319 26.8595C50.8937 26.4341 50.8937 25.7444 51.319 25.319C51.7444 24.8937 52.4341 24.8937 52.8595 25.319L69.8043 42.2639Z",
    fill: "#157438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosebtn);
export default __webpack_public_path__ + "static/media/closebtn.04380542d46b7557503c389185071168.svg";
export { ForwardRef as ReactComponent };